var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "-0.5 -0.5 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.584 7.248 7.229 1.946a1.22 1.22 0 0 0-.858-.352H1.213c-.67 0-1.213.538-1.213 1.2v5.109c0 .318.128.624.355.85l5.355 5.301c.474.47 1.242.47 1.715 0l5.159-5.108c.474-.469.474-1.23 0-1.698zM2.83 5.598c-.67 0-1.213-.538-1.213-1.202 0-.663.543-1.2 1.213-1.2s1.213.537 1.213 1.2c0 .664-.543 1.202-1.213 1.202zM15.82 8.946l-5.159 5.108c-.474.47-1.242.47-1.715 0l-.01-.009 4.4-4.355c.429-.426.666-.991.666-1.593 0-.601-.237-1.167-.667-1.592L8.375 1.594h1.231c.322 0 .63.126.858.352l5.355 5.302c.473.469.473 1.23 0 1.698z",
    id: "loh78pnxxa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.ebcd9488c8e9155fb1afbe79ce1e1b3c.svg";
export { ForwardRef as ReactComponent };